import React from 'react';
import PropTypes from 'prop-types';
import { StyledPopup, PopupWithoutImage, PopupTexts } from './styled';
import { NOTIFICATION_TEXTS } from '../../notifications';

const Notification = ({ name, getButton, imageSrc, imageAlt, onClose }) => {
  return (
    <PopupWithoutImage small onClose={onClose}>
      <PopupTexts>
        <h2>{NOTIFICATION_TEXTS[name].title}</h2>
        <p>{NOTIFICATION_TEXTS[name].description}</p>
        {getButton()}
      </PopupTexts>
      {imageSrc && <img src={imageSrc} alt={imageAlt} />}
    </PopupWithoutImage>
  );
};

Notification.propTypes = {
  name: PropTypes.string.isRequired,
  getButton: PropTypes.func.isRequired,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  onClose: PropTypes.func.isRequired
};

export default Notification;
